import type { Claim } from '@/types/claim'
import type { ClaimResponse } from '@/types/responses/claimResponse'
import type NotificationMessage from '~/types/notificationMessage'

export const useClaimsStore = defineStore('claims', {
  state: () => ({
    claims: [] as Claim[],
    summaryClaims: [] as Claim[],
    claimsMessages: {
      newestMessages: [],
      oldMessages: []
    } as { newestMessages: NotificationMessage[]; oldMessages: NotificationMessage[] }
  }),
  actions: {
    setClaims(claims: Claim[]) {
      this.claims = claims
    },
    setSummaryClaims(claims: Claim[]) {
      this.summaryClaims = claims
    },
    async getClaim(claimId: string) {
      const policyStore = usePolicyStore()

      const { selectedPolicy } = policyStore

      const { response } = useApi(`claims`, {
        params: {
          policyId: selectedPolicy.policyId,
          claimId
        }
      })

      const data = (await response) satisfies ClaimResponse

      return data
    },
    async getClaimMessages() {
      let claimCallIndex = 0
      while (claimCallIndex < this.claims.length) {
        const claim = this.claims[claimCallIndex]
        if (claim) {
          if (claim.messagesCount > 0) {
            const { oldMessages, newestMessage } = (await this.getClaim(claim.claimId)) as ClaimResponse
            if (oldMessages) this.claimsMessages.oldMessages = [...this.claimsMessages.oldMessages, ...oldMessages]
            if (newestMessage) this.claimsMessages.newestMessages.push(newestMessage)
          }
        }

        claimCallIndex++
      }
      return this.claimsMessages
    }
  }
})
